module.exports = __webpack_public_path__ + "static/media/select_list_icon.478ec39c.svg";